import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import IWMSDashboard from "./components/Dashboard/IWMSDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/newdashboard" element={<IWMSDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;